import { toast } from "sonner";
import { JourneyField as Field, JourneySelect as Select } from "../../controls";
import { JOURNEY_ENGLISH_OPTIONS } from "../../options";
import { EnglishAssessmentFields } from "../EnglishAssessmentFields";

export const EnglishStep = ({ answers, update }) => (
  <div>
    <h2 className="font-display text-3xl font-bold tracking-tight text-ink">Your English-language evidence</h2>
    <p className="mt-2 text-sm leading-6 text-slatey">This opportunity asks for English-language evidence. Answer in your own terms — OpenDegree can assess indicatively if you have no evidence yet.</p>
    <div className="mt-6 max-w-xl">
      <Field label="English-language status"><Select value={answers.english_status} onChange={(v) => update("english_status", v)} testId="journey-english-status" placeholder="Select English status" options={JOURNEY_ENGLISH_OPTIONS} /></Field>
      {answers.english_status === "no_current_evidence" && (
        <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 p-4" data-testid="english-no-evidence-action">
          <p className="text-sm leading-6 text-amber-800"><strong>You don’t currently have English-language evidence.</strong> OpenDegree can assess your English indicatively, or you can continue and identify whether evidence is required later.</p>
          <div className="mt-3 flex flex-wrap gap-2">
            <button onClick={() => update("english_status", "needs_assessment")} data-testid="start-english-assessment-button" className="rounded-full bg-cobalt px-4 py-2.5 text-sm font-bold text-white">Assess English indicatively</button>
            <button onClick={() => toast.info("You can continue. The opportunity assessment will identify whether English evidence is required later.")} data-testid="continue-without-english-button" className="rounded-full border border-slate-300 bg-white px-4 py-2.5 text-sm font-bold text-ink">Continue without evidence</button>
          </div>
        </div>
      )}
      {answers.english_status === "needs_assessment" && (
        <div className="mt-6" data-testid="english-assessment-next">
          <p className="rounded-2xl bg-cobalt/5 p-4 text-sm font-semibold text-cobalt">OpenDegree’s indicative English assessment. This is not an official English qualification or SELT.</p>
          <EnglishAssessmentFields answers={answers} update={update} />
        </div>
      )}
    </div>
  </div>
);
